// Ekranların kullandığı react-native export'ları + Text/TextInput override'ı
// (AppText'ten, Inter fontlu). `export * from 'react-native'` RN'in tembel
// getter'larını tetikleyip "native module doesn't exist" hatası verdiği için
// kullanılan isimleri açıkça listeliyoruz.
export {
  ActivityIndicator,
  ActionSheetIOS,
  Alert,
  Animated,
  BackHandler,
  Dimensions,
  FlatList,
  I18nManager,
  Image,
  KeyboardAvoidingView,
  Linking,
  Modal,
  PanResponder,
  Platform,
  ScrollView,
  Switch,
  Share,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';

export { Text, TextInput } from './AppText';
